module.exports = __webpack_public_path__ + "media/applications/assets/images/size-info/summer_dress-685d6ca8d0d2276263194aafbd8dc16e.png";